export default __webpack_public_path__ + "static/media/caleta_olivia.e9745fca.jpg";